import crypto from "crypto";
import CryptoJs from "crypto-js";
import HttpMethod from "../constants/HttpMethod";

const KEY = process.env.GATSBY_SECRET_KEY;
const URL = process.env.GATSBY_ROOT_API_URL;

export const requestHashFromFileEvent = (e: any, modelId: string) => {
  const contents = e.target?.result;
  const fileHash = getFileHash(contents);
  const date = new Date().toISOString();
  const requestHash = getRequestHash(date, fileHash, modelId);
  return {
    date,
    requestHash,
  };
};

export const getRequestHash = (
  date: string,
  fileHash: string,
  model_id: string
): string => {
  const message = `${HttpMethod.post}\n${URL}\n${date}\nmultipart/form-data\n${fileHash}\n${model_id}`;

  const hash = generateHash(message);
  return hash;
};

const generateHash = (message: string) => {
  if (!KEY) return "";
  const hash = crypto
    .createHmac("sha256", KEY)
    .update(message)
    .digest("hex");

  return hash;
};

export const getFileHash = (
  contents: ArrayBuffer | string | undefined | null
) => CryptoJs.SHA256(CryptoJs.enc.Latin1.parse(contents)).toString();
